import './index.scss'
import React from 'react'
import { Modal } from 'antd'
import NextBtn from '../next-btn'

export const ModalMethod = (props) => {
  const { t } = props
  const errText = t('anan_resp_quotation_not_in_HK_tips') || 'Apologies as you are currently not located in Hong Kong. As per regulation, our products can only be offered to applicants in Hong Kong. Please visit us again next time you are in Hong Kong.'
  const modal = Modal[props.method || 'info']({
    width: props.width || 540,
    centered: true,
    className: 'anan-res-modal-info',
    content: (
      <>
        <div className='pb50'>{props.content || errText}</div>
        <NextBtn
          onClick={() => {
            props.onConfirm && props.onConfirm()
            modal.destroy()
          }} type='special' text={t('anan_resp_common_ok') || 'OK'}
        />
      </>
    )
    // ...props
  })
}
